<template>
  <div class="container error-message">
    <h1>
      {{ msg }}
    </h1>
    <router-link :to="{name:'Home'}">
      <button class="btn btn-primary">
        Back to Toolkit Home
      </button>
    </router-link>
  </div>
</template>

  <script>
  export default {
    name: 'ErrorPage',
    props: {
      msg: {
        type: String,
        default: ''
      }
    }
  };
  </script>

  <style scoped>
  .error-message{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    width: 100%;
  }
  .error-message button {
    margin: 2rem;
  }
  </style>